<template>
  <modal
    :id="modalId"
    class="with-subtitle"
    ref="modal"
    title="Subscription update"
    is-simplified-modal
    @close="close"
  >
    <template v-slot:title>
      <h2 class="title">Subscription update</h2>
    </template>

    <template v-slot:body>
      <template v-if="hasRequestBeenApprovedByUser">
        <div class="tw-flex flex-col p-4">
          <div>
            Thank you, your request has been received.
          </div>
          <div>
            An administrator will review your request and process it shortly.
          </div>
        </div>
      </template>

      <template v-else>
        <div class="p-4 min-h-[200px]" v-if="!hasRequestBeenApprovedByUser">
          <div class="tw-flex items-center">
            Thank you for your request, please confirm that you would like to change your subscription package.
          </div>

          <div>
            Upon clicking 'Yes', our team will review your request and process it shortly.
          </div>
        </div>
      </template>
    </template>

    <template v-slot:footer>
      <div v-if="!hasRequestBeenApprovedByUser">
        <DsButton
          variant="primary"
          label="Yes"
          @click="confirmPackageChange"
        />

        <DsButton
          variant="secondary"
          label="No"
          :disabled="isSubmitting"
          @click="close"
        />
      </div>

      <div v-else>
          <div class="tw-mt-4">
            <DsButton
              variant="primary"
              label="Close"
              @click="close"
            />
          </div>
      </div>
    </template>

  </modal>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { requestSubscriptionChange } from '@/api/user'
  import MODAL_IDS from '@/constants/modal-ids'
  import Modal from '@/components/Modals/Modal.vue'
  import Dropdown from '@/components/Dropdown/Dropdown.vue'
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '@/store/modules/ui'

  export default defineComponent({
    name: "ConfirmEcosystemMemberPackageChangeRequest",
    components: {
      Dropdown,
      Modal
    },
    data() {
      return {
        modalId: MODAL_IDS.CONFIRM_ECOSYSTEM_MEMBER_PACKAGE_CHANGE_REQUEST,
        hasRequestBeenApprovedByUser: false,
        isSubmitting: false
      }
    },
    mounted () {
      console.log(this.packageId)
    },
    computed: {
      packageId() {
        return this.$store.state.ui.modalContext.selectedPackage.id
      }
    },
    methods: {
      confirmPackageChange() {
        this.isSubmitting = true

        requestSubscriptionChange(this.packageId)
          .then(() => {
            this.isSubmitting = false
            this.hasRequestBeenApprovedByUser = true
          })
          .catch(() => {
            this.isSubmitting = false
          })
      },
      close() {
        this.$store.commit(UI_MUTATION_TYPES.HIDE_MODAL, this.modalId)
        this.$store.commit(UI_MUTATION_TYPES.SET_MODAL_CONTEXT, null)
        this.$emit('close')
      }
    }
  })
</script>

<style scoped lang="scss">

</style>
